import constants from "@/constants";

export default {
  data() {
    return {
      assignments: [],
      assignmentLoading: true,
      orgId: "",
      orgColor: "",
      constants,
      doneItemsLoading: true,
      doneUsersItems: [],
    };
  },
  computed: {
    orgData() {
      return this.$store.state.organization.orgData;
    },
    orgAssignments() {
      return this.$store.state.alex.orgAssignments;
    },
    avatarNameGenerator() {
      return this.$store.state.users.avatarNameGenerator;
    },
    userData() {
      return this.$store.state.users.data;
    },
  },
  watch: {
    orgData: {
      handler(newVal, oldVal) {
        if (newVal !== oldVal && Object.keys(oldVal).length > 0) {
          if (this.orgAssignments && this.orgAssignments.length === 0) {
            this.getOrgAssignments(newVal._id);
          }
          if (this.doneUsersItems && this.doneUsersItems.length === 0) {
            this.getDoneUsersItems(this.orgData._id);
          }
          this.orgId = newVal._id;
          this.orgColor = newVal.primaryThemeColor
            ? newVal.primaryThemeColor
            : "#fbbf15";
        }
      },
      deep: true,
      setImmediate: true,
    },
  },
  methods: {
    getOrgAssignments(orgId) {
      this.$store
        .dispatch("alex/getOrgAssignments", orgId)
        .then((res) => {
          if (res && this.orgAssignments.length === 0) {
            this.assignments = res.data;
          }
        })
        .catch(() => {})
        .finally(() => {
          this.assignmentLoading = false;
        });
    },
    borderStyle(status, isUserValidated) {
      let borderColor;
      if (status === "done") {
        if (isUserValidated) {
          borderColor = "#12B76A";
        } else {
          borderColor = "#F29300";
        }
      } else if (status === "doing") {
        borderColor = "#F29300";
      } else {
        borderColor = "red";
      }
      return {
        border: `3px solid ${borderColor}`,
      };
    },
    getDoneUsersItems(orgId) {
      if (orgId) {
        this.$store
          .dispatch("alex/fetchDoneUsersItems", orgId)
          .then((res) => {
            if (res && res.data.length > 0) {
              this.doneUsersItems = res.data;
            }
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            this.doneItemsLoading = false;
          });
      }
    },
  },
  mounted() {
    if (this.orgData && this.orgData._id) {
      if (this.orgAssignments && this.orgAssignments.length === 0) {
        this.getOrgAssignments(this.orgData._id);
      }
      if (this.doneUsersItems && this.doneUsersItems.length === 0) {
        this.getDoneUsersItems(this.orgData._id);
      }
    }
    if (this.orgData && this.orgData._id) {
      this.orgId = this.orgData._id;
      this.orgColor = this.orgData.primaryThemeColor
        ? this.orgData.primaryThemeColor
        : "#fbbf15";
    }
  },
};
